import { WorkExperiencesType } from "../services/models/WorkServiceModels";

//TODO DOCUMENTATION AND FORMATTING

export const JobDescription = ({
  company,
  role,
  dateStarted,
  dateEnded,
}: WorkExperiencesType) => {
  return (
    <div id="job-description" className="flex flex-col justify-center">
      <h2 className="text-xl mb-3 items-center flex bg-ultramarine/10 pl-3 rounded-xl py-1">
        {company}
      </h2>
      <div className="h-28">
        <p className="font-raleway text-lg ml-3">
          <b className="font-bold">Position:</b> {role}
        </p>
        <p className="font-raleway text-lg ml-3">
          <b className="font-bold">Period:</b>
          {` ${dateStarted.toLocaleDateString("default", { month: "long" }).slice(0, 3)} 
                                ${dateStarted.getFullYear()} 
                                ${
                                  dateEnded
                                    ? `- ${dateEnded.toLocaleDateString("default", { month: "long" }).slice(0, 3)} 
                                ${dateEnded.getFullYear()}`
                                    : ""
                                }
                                `}
        </p>
      </div>
    </div>
  );
};
